import { ErrorMessage, Field } from "formik";
import React from "react";
import TextError from "./TextError";
import { valudatesetformstatus } from "../../pages/onboarding/Onboarding";

const CheckBoxGroup = (props: any) => {
    const { name, label, option, className, allData, completedPage, candidateData, initialCandidateName, ...rest } = props;

    const fieldValidation = (value: any) => {
        let error;
        if (allData.validate) {
            if (allData.type === "checkbox-group" || allData.type === "checkbox") {
                allData?.validations.forEach((element: any) => {
                    if (allData.type === "checkbox-group" || allData.type === "checkbox") {
                        if ((!value || value?.length === 0) && valudatesetformstatus !== "draft" ) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else if (!value && valudatesetformstatus === "draft" && completedPage) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        }
                    }
                });
            }
        }
        return error;
    };
    return (
        <>
            <Field name={name} validate={fieldValidation} onBlur={(e: any) => e.preventDefault()} {...rest}>
                {
                    ({ field }: any) => {
                        return option.map((ress: any) => {
                            let newAgreeLabel : string = "";
                            if(ress.value === "Agree"){
                                let updatedCandidateName : string = "";
                                
                                const personalDetails = candidateData?.data.find((form: any) => form?.label === "Personal Details");
                                if (personalDetails) {
                                    const firstName = personalDetails.fields.find((fieldRow: any) => fieldRow?.label === "First Name")?.value || "";
                                    const lastName = personalDetails.fields.find((fieldRow: any) => fieldRow?.label === "Last Name")?.value || "";
                                    updatedCandidateName = `${firstName} ${lastName}`.trim();
                                }
                                if(ress.label.includes(initialCandidateName)){
                                    if (ress.label && updatedCandidateName !== "") {
                                        newAgreeLabel = ress.label.replace(initialCandidateName, updatedCandidateName);
                                        localStorage.setItem("newCandidateName", updatedCandidateName);
                                    }
                                }

                            }
                            return (
                                <div key={ress.value} className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={allData.name}
                                        {...field}
                                        value={ress.value}
                                        checked={field?.value?.includes(ress.value)}
                                    />
                                    <label className={`form-check-label  ${ress?.fontWeightClass ? ress?.fontWeightClass : "fw-700"}`} htmlFor={allData.name}><span></span>{newAgreeLabel ? newAgreeLabel : ress.label} {allData.required && allData.type === "checkbox" ? <span className="star">*</span> : ""}</label>
                                </div>
                            );

                        });
                    }
                }
            </Field>
            <ErrorMessage name={name} component={TextError} />

        </>
    );
};

export default CheckBoxGroup;